import { MenuItemDef } from '@bpba/ui-components';

export type AppMenuLink = MenuItemDef & { href: string };

export const MENU_LINKS: AppMenuLink[] = [
  { value: 'solicitar', label: 'Solicitar turno', href: '/' },
  { value: 'reprogramar', label: 'Reprogramar turno', href: '/reprogramar' },
  { value: 'descargar', label: 'Descargar turno', href: '/descargar' },
  { value: 'cancelar', label: 'Cancelar turno', href: '/cancelar' },
];
